import SymbolBoneText from '@/components/symbols/boneText.vue';
export default {
    name: 'BoneTenYears',
    components: {
        SymbolBoneText
    }
};
